import styled from 'styled-components'
import breakpoint from '../../../../commons/breakpoints'

// eslint-disable-next-line import/prefer-default-export
export const JobItemWrapper = styled.div`
  margin: 15px;
  .ant-card:hover {
    border: ${(props) => `2px solid ${props.theme.theme.primaryColor}`};
    cursor: pointer;
  }
  .ant-card {
    transition: 0.15s ease all;
    border-radius: 8px;
    border-width: 2px;
  }
  .job-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    p {
      margin-bottom: 5px;
    }
    .job-title {
      font-size: 20px;
      font-weight: 700;
      margin-right: 10px;
      letter-spacing: 0.2px;
      text-transform: capitalize;
    }

    .job-info,
    .job-apply {
      display: flex;
      flex-direction: column;
    }
    .job-location {
      opacity: 0.55;
    }
    .job-apply p {
      font-size: 16px;
      color: #1890ff;
      text-decoration: none;
      background-color: #0000;
      outline: none;
      cursor: pointer;
      -webkit-transition: color 0.3s;
      transition: color 0.3s;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-bottom: 0;
    }

    .job-title-wrapper {
      display: flex;
      align-items: center;
    }
  }

  @media only screen and ${breakpoint.device.s} {
    .job-item {
      flex-direction: column;
      align-items: flex-end;

      .job-title {
        font-size: 16px;
      }
      .job-info,
      .job-apply {
        width: 100%;
      }

      .job-apply {
        align-items: flex-end;
      }

      .job-title-wrapper {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
      }
    }
  }
`
